/** @jsx isolateComponent */
import React from 'react';
import { isolateComponent } from '@zapier/style-encapsulation';
import { Spacer } from '@zapier/design-system';
import List from '@zapier/product-get-help/esm/components/shared/List';
import RadioInput from '@zapier/product-get-help/esm/components/shared/RadioInput';
import Surface from '@zapier/product-get-help/esm/components/shared/Surface';
const CustomError = ({ message, onClick, }) => {
    if (!message || !onClick) {
        return null;
    }
    return (isolateComponent(React.Fragment, null,
        isolateComponent("p", null, "It looks like you were troubleshooting an error"),
        isolateComponent(Spacer, { height: 10 }),
        isolateComponent(RadioInput, { icon: "alertTriangle", label: message, onClick: onClick }),
        isolateComponent(Spacer, { height: 20 }),
        isolateComponent("p", null, "Other issues"),
        isolateComponent(Spacer, { height: 10 })));
};
/**
 * Renders a block with a list of items using the `RadioInput` component.
 */
const ErrorBlock = ({ title, customError, items: items, onClickCustom, onClickItem, size = 'large', }) => {
    return (isolateComponent(Surface, { size: size, title: title },
        isolateComponent(Spacer, { height: 20 }),
        isolateComponent(CustomError, { message: customError, onClick: onClickCustom }),
        isolateComponent(List, { gap: 5, itemRenderer: (item) => (isolateComponent(RadioInput, { label: item.label, onClick: () => onClickItem(item) })), items: items })));
};
export default ErrorBlock;
